import { isEmpty } from "lodash-es";
import React from "react";
import { getColor } from "../../utils/color";
import { comma } from "../../utils/number";
import { classnames, combinePrefixes } from "../../utils/text";
import Loading from "../Loading";
import NoData from "../NoData/NoData";


const RankList = ({
  color,
  list = [],
  isLoading,
}) => {
  const pointColor = getColor(color);
  return <div className="custom-list rank-list">
    {isLoading ?
      <Loading /> :
      isEmpty(list) ? <NoData /> :
        list.map(({ label, data }, idx) => (
          <div
            className={classnames(combinePrefixes('ranking', [idx + 1], undefined, true))} key={idx}
          >
            <span
              className="rank"
              style={{
                color: pointColor,
                opacity: 1 - ((1 / list.length) * idx)
              }}
            >{idx + 1}</span>
            <div className="rank-box">
              <span className="rank-label ellipsis">{label}</span>
              <span className="rank-data ellipsis">{comma(data)}</span>
            </div>
          </div>
        ))
    }
  </div >
}
export default RankList